<template>
    <div class="container-fluid layout-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header admin-header">
                        <h3 class="text-accent-light">پیام های کاربر</h3>
                    </div>
                    <div>
                        <small class="d-inline-block text-center">برای مشاهده متن کامل پیام، روی آن کلیک کنید</small>
                    </div>


                    <div v-if="!isLoading">
                        <div v-if="messages.length===0">
                            <h5 class="text-center mt-3">شما پیامی ندارید</h5>
                        </div>
                        <div class="table-responsive" v-else>

                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th>تاریخ</th>
                                    <th>پیام</th>
                                    <th>تاریخ ارسال</th>
                                    <th>وضعیت</th>
                                    <th>عملیات</th>

                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="it in messages">
                                    <td>{{it.prdate}}</td>
                                    <td ><a @click="">{{it.message}}</a></td>
                                    <td>{{it.prdate2}}</td>
                                    <td class="text-nowrap">{{it.showStatus}}</td>
                                    <td class="text-center text-nowrap">
                                        <button class="btn btn-primary btn-round" @click="onViewMessageClicked(it.id)">
                                            مشاهده متن کامل پیام
                                        </button>
                                    </td>

                                </tr>
                                </tbody>
                            </table>


                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from "../_framework/VsSelect";
    import DatePicker from "../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker";
    import Moment from "moment-jalali";

    export default {
        name: "messages",
        components: {VsSelect, DatePicker},
        data() {
            return {
                isLoading: false,
                types: [{
                    id: 5,
                    name: "وام عادی"
                }],
                opType: [
                    {
                        id: 0,
                        name: "پرداختها"
                    },
                    {
                        id: 1,
                        name: "دریافتها"
                    },
                    {
                        id: 2,
                        name: "پرداختها و دریافتها"
                    },

                ],
                messages: [],


                reportModel: {
                    fromDate: "",
                    toDate: "",
                    type: 0,
                    isDebtor: null
                },
                fromDate: "",
                toDate: "",
                send_status: 0,
                show_status: 0,
            }
        },
        mounted() {
            // this.getUserCompetitions();
            // this.getFields();
            // this.getProvinces();
            this.getmessages();
        },
        methods: {
            getmessages() {
                this.isLoading = true;
                // new BaseService("Report",

                //     "/messages/fromDate=" + this.reportModel.fromDate + "/toDate=" + this.reportModel.toDate + "/type=" + this.reportModel.type + "/isDebtor=" + this.reportModel.isDebtor
                // ).getList().then(response => {
                new BaseService("MemberMessages", "/MemberMessages/" + this.send_status + "/" + this.show_status).getList().then(response => {
                    this.isLoading = false;
                    this.messages = response.data.data;
                    for (let it of this.messages) {
                        it.prdate = Moment(it.createdOn, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')
                        it.prdate2 = Moment(it.messageDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')
                    }
                    // this.userMatchesPagination.currentPage = response.data.pageIndex + 1;
                    // this.userMatchesPagination.totalRows = response.data.count;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                })
            },


            toggleFromDatePicker() {
                this.$refs.fromDate.togglePicker();
            },
            onFromDatePicked(val) {
                this.reportModel.fromDate = this.jalaliToGregorian(val);
                this.fromDate = this.gregorianToJalaliBeautified(this.jalaliToGregorian(val), true);
                this.getmessages();
            },
            toggleToDatePicker() {
                this.$refs.toDate.togglePicker();
            },
            onToDatePicked(val) {
                this.reportModel.toDate = this.jalaliToGregorian(val);
                this.toDate = this.gregorianToJalaliBeautified(this.jalaliToGregorian(val), true);
                this.getmessages();
            },
            onPaymentConfirmed() {
                if (this.paymentMethod === "online") {
                    this.payOnline();
                }
                if (this.paymentMethod === "cash") {
                    this.payByCash();
                }
                if (this.paymentMethod === "wallet") {
                    this.payByWallet();
                }
            },

            onShowDiagramClicked(id) {
                this.tournamentBracketId = id;
                this.$refs.tournamentBracketModal.showModal();
            },

            validateDate(date) {
                return Moment(date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY')
            },
            onTypeChange(val) {
                if (val !== null) {
                    this.reportModel.type = val.id;
                    this.getmessages();
                } else {
                    this.reportModel.type = 0;
                    this.getmessages();
                }
            },
            onOpTypeChange(val) {
                if (val !== null) {
                    switch (val.id) {
                        case 0:
                            this.reportModel.isDebtor = false;
                            this.getmessages();
                            break;
                        case  1:
                            this.reportModel.isDebtor = true;
                            this.getmessages();

                            break;
                        case  2:
                            this.reportModel.isDebtor = null;
                            this.getmessages();

                            break;
                    }

                } else {
                    this.reportModel.type = 0;
                    this.getmessages();
                }
            },
            onViewMessageClicked(id) {

                this.$router.push({
                    name: 'readmessage',
                    params: {
                        id: id
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .payment-options-container {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
        margin-top: 1.5rem;
    }

    .payment-option {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        background-color: #ffffff;
        border-radius: 0.25rem;
        padding: 0.5rem;
        box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.5);
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.3s;
    }

    .payment-option.active {
        border: 2px solid #40c4ff;
        box-shadow: 0 5px 15px -2px #40c4ff;
    }

    .payment-option img {
        max-width: 100px;
    }

    .payment-option small {
        color: #333333;
        margin-top: 0.5rem;
    }

    .wallet-payment-wrapper {
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>